var map = {
	"./application.svg": 99456,
	"./asset.svg": 9426,
	"./container.svg": 26251,
	"./group.svg": 37535,
	"./role.svg": 15918,
	"./tag.svg": 64326,
	"./team.svg": 28961,
	"./user.svg": 69423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79290;